import ParentCss from "../../style.module.scss";

import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { Button, Preloader } from "nlib/ui";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import CustomPromptTypes from "const/CustomPromptTypes";
import EditPrompt from "./lib/EditPrompt";
import GptAiExcludeRules from "const/GptAiExcludeRules";
import React, { useCallback, useEffect, useState } from "react";

const MAX_ADDITIONAL_PROMPTS_COUNT = 10;

const {
  ADDITIONAL,
  ATM_WITHDRAWALS,
  CHECKS,
  EXPENSE_REIMBURSEMENTS,
  MARKETPLACES,
  PERSON_TO_PERSON_PAYMENTS,
  PAYMENT_SYSTEMS,
  PAYROLL_SYSTEMS,
  TRANSFERS
} = CustomPromptTypes;

const EXCLUDE_RULE_TO_PROMPT_TYPES = {
  [GptAiExcludeRules.PAYMENT_SYSTEM]: PAYMENT_SYSTEMS,
  [GptAiExcludeRules.PAYROLL_SYSTEM]: PAYROLL_SYSTEMS,
  [GptAiExcludeRules.ATM_WITHDRAWAL]: ATM_WITHDRAWALS,
  [GptAiExcludeRules.EXPENSE_REIMBURSEMENT]: EXPENSE_REIMBURSEMENTS,
  [GptAiExcludeRules.MARKETPLACE]: MARKETPLACES,
  [GptAiExcludeRules.TRANSFER]: TRANSFERS,
  [GptAiExcludeRules.CHECK]: CHECKS,
  [GptAiExcludeRules.PERSON_TO_PERSON_PAYMENT]: PERSON_TO_PERSON_PAYMENTS,
  [GptAiExcludeRules.UNCLEAR]: ADDITIONAL
};

const AiBookkeeperTab = ({ disabled, customPrompts, extraData: { gptAiCategory = "" } = {}, onChange }) => {
  const { uiTexts, messages } = useSelector(getTextsData);

  const [focused, setFocused] = useState(null);

  const handleAddCustomPrompt = useCallback(() => {
    onChange(CustomPromptTypes.ADDITIONAL);
  }, [onChange]);

  const handleRemove = useCallback((index) => {
    onChange(`${ADDITIONAL}.${index}`, null);
  }, [onChange]);

  useEffect(() => {
    if (gptAiCategory) {
      const promptData = gptAiCategory === GptAiExcludeRules.UNCLEAR
        ? (customPrompts.additional || [])[0]
        : customPrompts[EXCLUDE_RULE_TO_PROMPT_TYPES[gptAiCategory]];

      if (!promptData?.active) {
        onChange(EXCLUDE_RULE_TO_PROMPT_TYPES[gptAiCategory], { active: true, text: promptData?.text || "" });
        setFocused(EXCLUDE_RULE_TO_PROMPT_TYPES[gptAiCategory]);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);

  return (
    <>
      <div className={ParentCss.row}>
        <EditPrompt
          disabled={disabled}
          focused={focused === PAYMENT_SYSTEMS}
          type={PAYMENT_SYSTEMS}
          label={uiTexts.paymentSystemsRules}
          description={messages.customPromptsPaymentSystemsDescription}
          placeholder={messages.customPromptsPaymentSystemsPlaceholder}
          value={customPrompts[PAYMENT_SYSTEMS] || ""}
          onChange={onChange} />
      </div>
      <div className={ParentCss.row}>
        <EditPrompt
          disabled={disabled}
          focused={focused === PAYROLL_SYSTEMS}
          type={PAYROLL_SYSTEMS}
          label={uiTexts.payrollSystemsRules}
          description={messages.customPromptsPayrollSystemsDescription}
          placeholder={messages.customPromptsPayrollSystemsPlaceholder}
          value={customPrompts[PAYROLL_SYSTEMS] || ""}
          onChange={onChange} />
      </div>
      <div className={ParentCss.row}>
        <EditPrompt
          disabled={disabled}
          focused={focused === EXPENSE_REIMBURSEMENTS}
          type={EXPENSE_REIMBURSEMENTS}
          label={uiTexts.expenseReimbursementsRules}
          description={messages.customPromptsExpenseReimbursementsDescription}
          placeholder={messages.customPromptsExpenseReimbursementsPlaceholder}
          value={customPrompts[EXPENSE_REIMBURSEMENTS] || ""}
          onChange={onChange} />
      </div>
      <div className={ParentCss.row}>
        <EditPrompt
          disabled={disabled}
          focused={focused === MARKETPLACES}
          type={MARKETPLACES}
          label={uiTexts.marketplacesRules}
          description={messages.customPromptsMarketplacesDescription}
          placeholder={messages.customPromptsMarketplacesPlaceholder}
          value={customPrompts[MARKETPLACES] || ""}
          onChange={onChange} />
      </div>
      <div className={ParentCss.row}>
        <EditPrompt
          disabled={disabled}
          focused={focused === TRANSFERS}
          type={TRANSFERS}
          label={uiTexts.transfersRules}
          description={messages.customPromptsTransfersDescription}
          placeholder={messages.customPromptsTransfersPlaceholder}
          value={customPrompts[TRANSFERS] || ""}
          onChange={onChange} />
      </div>
      <div className={ParentCss.row}>
        <EditPrompt
          disabled={disabled}
          focused={focused === PERSON_TO_PERSON_PAYMENTS}
          type={PERSON_TO_PERSON_PAYMENTS}
          label={uiTexts.p2pPaymentsRules}
          description={messages.customPromptsP2PPaymentsDescription}
          placeholder={messages.customPromptsP2PPaymentsPlaceholder}
          value={customPrompts[PERSON_TO_PERSON_PAYMENTS] || ""}
          onChange={onChange} />
      </div>
      <div className={ParentCss.row}>
        <EditPrompt
          disabled={disabled}
          focused={focused === ATM_WITHDRAWALS}
          type={ATM_WITHDRAWALS}
          label={uiTexts.atmWithdrawalsRules}
          description={messages.customPromptsAtmWithdrawalsDescription}
          placeholder={messages.customPromptsAtmWithdrawalsPlaceholder}
          value={customPrompts[ATM_WITHDRAWALS] || ""}
          onChange={onChange} />
      </div>
      <div className={ParentCss.row}>
        <EditPrompt
          disabled={disabled}
          focused={focused === CHECKS}
          type={CHECKS}
          label={uiTexts.checkingChequeRules}
          description={messages.customPromptsBankCheckDescription}
          placeholder={messages.customPromptsBankCheckPlaceholder}
          value={customPrompts[CHECKS] || ""}
          onChange={onChange} />
      </div>
      {(customPrompts.additional || []).map((value, index) => {
        return (
          <div key={String(index + 1)} className={ParentCss.row}>
            <EditPrompt
              removable
              focused={focused === ADDITIONAL}
              disabled={disabled}
              type={`${ADDITIONAL}.${index}`}
              label={`${uiTexts.additionalInstructions} ${index + 1}`}
              placeholder={messages.customPromptsAdditionalPlaceholder}
              index={index}
              value={value}
              onRemove={handleRemove}
              onChange={onChange} />
          </div>
        );
      })}
      <div className={Css.addButtonWrap}>
        <Button
          outline large
          icon={Icons.Plus}
          disabled={disabled || (customPrompts.additional || []).length >= MAX_ADDITIONAL_PROMPTS_COUNT}
          onClick={handleAddCustomPrompt}>
          <span>{uiTexts.addCustomPrompt}</span>
        </Button>
      </div>
      {disabled && <Preloader absolute />}
    </>
  );
};

export default React.memo(AiBookkeeperTab);
